import { Result, ResultProps } from 'antd'

export interface KBResultProps extends ResultProps {}

export function KBResult(props: KBResultProps) {
  return <Result {...props}></Result>
}
